<nb-card class="c-body">
    <nb-card-header>
        <div class="form-header">
            <h3 class="form-title">
                <nb-icon icon="calendar-outline"></nb-icon>
                Availability Form
            </h3>
            <span class="form-subtitle">Configure domain, days, hours, and date range</span>
        </div>
    </nb-card-header>
    <nb-card-body>

        <div class="form-item-box">
            <fieldset>
                <legend>Domain</legend>
                <div class="d-check-item select-all" nbTooltip="Select All">Select All
                    <nb-checkbox [(checked)]="selectAllCheckedDomain" (checkedChange)="toggleSelectAll($event)"></nb-checkbox>
                </div>
                <div class="domainlist">
                    

                    <div class="d-check-item select-all" nbTooltip="Select All" *ngIf="groupOnline">Online
                        <nb-checkbox [(checked)]="selectAllOnlineDomain" (checkedChange)="toggleALlOnlineDomain($event)"></nb-checkbox>
                    </div>

                    <div class="d-check-item">Pos 
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('POS') > -1" (checkedChange)="toggleDomain($event,'POS')"></nb-checkbox>
                    </div>
                    <div class="d-check-item" *ngIf="!groupOnline"> Online Delivery
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('ONLINE_DELIVERY') > -1" (checkedChange)="toggleDomain($event,'ONLINE_DELIVERY')"></nb-checkbox>
                    </div>
                    <div class="d-check-item" *ngIf="!groupOnline"> Online Pickup
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('ONLINE_PICKUP') > -1" (checkedChange)="toggleDomain($event,'ONLINE_PICKUP')"></nb-checkbox>
                    </div>
                    <div class="d-check-item" *ngIf="!groupOnline"> Online App Delivery
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('ONLINE_APP_DELIVERY') > -1" (checkedChange)="toggleDomain($event,'ONLINE_APP_DELIVERY')"></nb-checkbox>
                    </div>
                    <div class="d-check-item" *ngIf="!groupOnline"> Online App Pickup
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('ONLINE_APP_PICKUP') > -1" (checkedChange)="toggleDomain($event,'ONLINE_APP_PICKUP')"></nb-checkbox>
                    </div>
                    <div class="d-check-item" *ngIf="!groupOnline"> Table Side
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('TABLE_SIDE') > -1" (checkedChange)="toggleDomain($event,'TABLE_SIDE')"></nb-checkbox>
                    </div>
                    <div class="d-check-item" > Kiosk
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('DM')&&form?.DM.indexOf('KIOSK') > -1" (checkedChange)="toggleDomain($event,'KIOSK')"></nb-checkbox>
                    </div>
                </div>
            </fieldset>


        </div>
        <div>
            <fieldset>
                <legend>Days</legend>
                <div class="d-check-item select-all" nbTooltip="Select All">Select All
                    <nb-checkbox [(checked)]="selectAllCheckedDays" (checkedChange)="toggleSelectAllDays($event)"></nb-checkbox>
                </div>
                <div class="dayslist">
                    <div class="d-check-item">Sun
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('0') > -1" (checkedChange)="toggleDay($event,'0')"></nb-checkbox>
                    </div>
                    <div class="d-check-item">Mon
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('1') > -1" (checkedChange)="toggleDay($event,'1')"></nb-checkbox>
                    </div>
                    <div class="d-check-item">Tue
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('2') > -1" (checkedChange)="toggleDay($event,'2')"></nb-checkbox>
                    </div>
                    <div class="d-check-item">Wed
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('3') > -1" (checkedChange)="toggleDay($event,'3')"></nb-checkbox>
                    </div>
                    <div class="d-check-item">Thu
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('4') > -1" (checkedChange)="toggleDay($event,'4')"></nb-checkbox>
                    </div>
                    <div class="d-check-item">Fri
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('5') > -1" (checkedChange)="toggleDay($event,'5')"></nb-checkbox>
                    </div>
                    <div class="d-check-item">Sat
                        <nb-checkbox [checked]="form&&form.hasOwnProperty('D')&&form?.D.indexOf('6') > -1" (checkedChange)="toggleDay($event,'6')"></nb-checkbox>
                    </div>
                </div>
            </fieldset>
        </div>


        <div>
            <fieldset>
                <legend>Timings</legend>

                <div class="existing-hours" *ngIf="form&&form?.H">
                    <div class="existing-hour" *ngFor="let item of form?.H;index  as i">
                        <div class="time-display">
                            <nb-icon icon="clock-outline" class="time-icon"></nb-icon>
                            <span>{{convertTo12Hour(item.S)}} - {{convertTo12Hour(item.E)}}</span>
                        </div>
                        <button class="remove" (click)="removeTime(i)" nbTooltip="Remove this timing">
                            <nb-icon icon="close-outline"></nb-icon>
                        </button>
                    </div>
                </div>

                <div class="hours-item">
                    <div class="time-box">
                        <label class="label" for="from">Start Time</label>
                        <input 
                            type="time" 
                            class="time-input" 
                            [(ngModel)]="fromtime" 
                            (ngModelChange)="onTimeChange()"
                            step="300"
                            [class.error-input]="timeValidationError && fromtime && totime"
                        >
                    </div>
                    <div class="time-box">
                        <label class="label" for="end">End Time</label>
                        <input 
                            type="time" 
                            class="time-input" 
                            [(ngModel)]="totime" 
                            (ngModelChange)="onTimeChange()"
                            step="300"
                            [class.error-input]="timeValidationError && fromtime && totime"
                        >
                    </div>
                    <div class="add-button-wrapper">
                        <button 
                            nbButton
                            status="success" 
                            size="small"
                            (click)="addTime()"
                            [disabled]="!fromtime || !totime"
                        >
                            <nb-icon icon="plus-outline"></nb-icon>
                            ADD
                        </button>
                    </div>
                </div>

                <div class="time-validation-error" *ngIf="timeValidationError">
                    <nb-icon icon="alert-circle-outline"></nb-icon>
                    <span>{{timeValidationError}}</span>
                </div>

            </fieldset>


        </div>
        <div>
            <div>
                <fieldset>
                    <legend>Date Range</legend>
                    <div class="date-range-container">
                        <div class="date-input-group">
                            <label class="date-label">
                                <span class="label-text">From Date</span>
                                <span class="required-indicator" *ngIf="form?.ED && !form?.SD">*</span>
                            </label>
                            <input 
                                nbInput 
                                placeholder="Select start date" 
                                [(ngModel)]="startDate" 
                                [nbDatepicker]="startPicker"
                                (ngModelChange)="onStartDateChange($event)"
                                class="date-input"
                                [status]="form?.ED && !form?.SD ? 'danger' : 'basic'"
                            >
                            <nb-datepicker #startPicker [max]="endDate"></nb-datepicker>
                        </div>

                        <div class="date-separator">
                            <nb-icon icon="arrow-forward-outline"></nb-icon>
                        </div>

                        <div class="date-input-group">
                            <label class="date-label">
                                <span class="label-text">To Date</span>
                                <span class="optional-indicator">(Auto-filled, adjustable)</span>
                            </label>
                            <input 
                                nbInput 
                                placeholder="Auto-filled from start date" 
                                [(ngModel)]="endDate" 
                                [nbDatepicker]="endPicker"
                                (ngModelChange)="onEndDateChange($event)"
                                class="date-input"
                                [disabled]="!startDate"
                            >
                            <nb-datepicker #endPicker [min]="startDate"></nb-datepicker>
                        </div>

                        <div class="date-actions">
                            <button 
                                nbButton 
                                status="danger" 
                                size="small"
                                (click)="clearDate()"
                                *ngIf="startDate || endDate"
                                nbTooltip="Clear dates"
                            >
                                <nb-icon icon="close-outline"></nb-icon>
                                Clear
                            </button>
                        </div>
                    </div>

                    <div class="date-info" *ngIf="startDate">
                        <nb-icon icon="calendar-outline" class="info-icon"></nb-icon>
                        <span class="info-text">
                            <span *ngIf="endDate && formatDisplayDate(startDate) === formatDisplayDate(endDate)">
                                Selected: <strong>{{formatDisplayDate(startDate)}} (00:00 - 11:59 PM)</strong>
                            </span>
                            <span *ngIf="endDate && formatDisplayDate(startDate) !== formatDisplayDate(endDate)">
                                Date Range: <strong>{{formatDisplayDate(startDate)}} 00:00</strong> to <strong>{{formatDisplayDate(endDate)}} 11:59 PM</strong>
                            </span>
                            <span *ngIf="!endDate">
                                Selected: <strong>{{formatDisplayDate(startDate)}} (00:00 - 11:59 PM)</strong>
                            </span>
                        </span>
                    </div>

                </fieldset>
            </div>

        </div>




    </nb-card-body>
    <nb-card-footer>
        <div class="d-foot-action">
            <button nbButton type="button" status="danger" (click)="close(false)">CANCEL</button>
            <button nbButton type="button" class="mx-2" status="success" (click)="save()">{{type=='add'?'Create':'Update'}}</button>
        </div>

    </nb-card-footer>
</nb-card>